import { Resource } from '@topconagriculture/permissions';
import { WidgetFooterType, WidgetHeaderType, WidgetSize, WidgetType } from '../widget.types';
import { widgetSizeEditModalName } from '../WidgetConfig';
export const LoadDeviationWidgetConfig = {
    type: WidgetType.LOAD_DEVIATION,
    single: true,
    thumbnail: '/assets/images/dashboard/widget-catalog/load-deviation.jpg',
    title: 'widget:load_deviation:title',
    description: 'widget:load_deviation:description',
    permissions: [Resource.FEED_WIDGET_INGREDIENT_LOAD_DEVIATION],
    header: () => ({
        type: WidgetHeaderType.GENERIC,
        actions: [
            {
                title: 'common:settings',
                modal: widgetSizeEditModalName,
            },
        ],
    }),
    footer: () => ({
        type: WidgetFooterType.EMPTY,
        href: '',
        text: '',
    }),
    baseConfig: {
        type: WidgetType.LOAD_DEVIATION,
        w: 2,
        h: 2,
        x: 0,
        y: 0,
    },
    init: () => {
        return {
            type: WidgetType.LOAD_DEVIATION,
            config: { size: WidgetSize.XS },
            w: 2,
            h: 2,
            minW: 2,
            minH: 2,
            x: 0,
            y: 0,
        };
    },
};
//# sourceMappingURL=LoadDeviationWidgetConfig.js.map